import { forwardRef } from "react";
import { TextInputBase } from "./shared/TextInputBase.mjs";
import { jsx } from "react/jsx-runtime";
const TextInput = forwardRef(function (props, ref) {
  return /* @__PURE__ */jsx(TextInputBase, {
    ...props,
    ref
  });
});
export { TextInput };